import React, { useEffect } from 'react';
import { ContentContainer, Row, Col, Button, SectionHeader,
       IconNotificationError,Heading,tokens,pxToRem } from '@snsw-gel/react';
import styles from './LinkingError.module.scss';
import { dataLayer } from '../../../services/gtm-dataLayer';


const LinkingErrorPage = () => {
    const changeDetailsText='Change of name on a NSW Seniors Card or NSW Senior Savers Card',
        changeDetailsLink='https://www.service.nsw.gov.au/transaction/change-of-name-on-a-nsw-seniors-card-or-nsw-senior-savers-card',
        multipleAccountsText='Help with multiple accounts',
        multipleAccountsLink='https://www.service.nsw.gov.au/services/myservicensw-account/multiple-accounts',
        applyNewCardText='apply for NSW Seniors Card or Senior Savers Card',
        applyNewCardLink='https://www.service.nsw.gov.au/transaction/apply-for-a-nsw-seniors-card-or-nsw-senior-savers-card';

    useEffect(() => {
        const currentUrl=window.location.href;
        const pageName=window.location.href.split('/').pop();
        dataLayer(currentUrl,pageName);
    }, []);
    const internalLinkDatalayer = (linkText,positionId,destinationUrl)=>{
        window.dataLayer.push({
            'event':'component_interaction',
            'component_type':'link_internal',
            'component_text':linkText,
            'section_id':'page_content',
            'position_id': positionId,
            'destination_url': destinationUrl
        });
    };

    return (
        <>
            <SectionHeader className={ styles['heading-section'] }
                label='Apply or manage a NSW Seniors Card or NSW Senior Savers Card '>
                <Heading  className={ styles['align-heading'] } level={ 1 }>
                    <IconNotificationError className={ styles['error-icon'] }/>
                The details you provided do not match our records
                </Heading>
            </SectionHeader>
            <ContentContainer className={ styles['content-container'] }>

                <Row>
                    <Col span={ 9 }>
                        <Heading level={ 2 }>
                        Check the following possible reasons
                        </Heading>
                        <ul>
                            <li>If you have changed your name, your details may not match. To resolve this, visit our <a target='_self'
                                onClick={ ()=>internalLinkDatalayer(changeDetailsText,1,changeDetailsLink) }
                                href={ changeDetailsLink }>
                                {changeDetailsText}</a>
                           .</li>
                            <li>If you have been sharing your account or card, you may be mixing details. To resolve this, visit our <a target='_self'
                                onClick={ ()=>internalLinkDatalayer(multipleAccountsText,2,multipleAccountsLink) }
                                href={ multipleAccountsLink }>
                                {multipleAccountsText}</a>
                             .</li>
                            <li>If you do not have a card, or if you have one from outside NSW, you’ll need to <a target='_self'
                                onClick={ ()=>internalLinkDatalayer(applyNewCardText,3,applyNewCardLink) }
                                href={ applyNewCardLink }>
                                {applyNewCardText}</a>
                                 .</li>
                        </ul>
                    </Col>
                </Row>
                <Row>
                    <Col span={ 9 }>
                        <Heading level={ 3 }
                            style={ {
                                marginTop: `${pxToRem(tokens.spacing.lg)}`
                            } }
                        >Support</Heading>
                        <p>If you have any issues adding your card, visit your nearest  <a href='https://www.service.nsw.gov.au/service-centre'>service centre</a> or call us on <a aria-label='Call us on 1 3 7 7 8 8' href='tel:137788'>13 77 88</a>.</p>
                    </Col>
                </Row>
                <Button
                    className={ styles['myaccount-button'] }
                    variant='primary'
                    aria-label='Go to my Service New South Wales account'
                    onClick={ ()=>window.location.href='https://account.service.nsw.gov.au/overview' } >Go to MyServiceNSW Account
                </Button>
                <Button
                    className={ styles['home-button'] }
                    variant='secondary'
                    aria-label='Go to Service New South Wales homepage'
                    onClick={ ()=>window.location.href='https://www.service.nsw.gov.au/' }>Go to Service NSW homepage
                </Button>

            </ContentContainer>
        </>
    );
};

export default LinkingErrorPage;

